import React, { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { fetchAllowedMenus } from "../Services/APIService";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import LeadDetailsView from "../Components/LeadDetailsView";
import LeadGroupAssign from "../Components/LeadGroupAssign";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import UserTask from "../Components/CreateUserTask";
import UserTasksView from "../Components/UserTasksView";
import LeadPreference from "../Components/LeadPreference";
import LeadDashboardView from "../Components/LeadDashboardView";
import UserTaskDashboard from "../Components/UserTaskDashboard";
import UserTasksViewDashboard from "../Components/UserTaskViewDashboard";
import LeadPreferenceDashboardView from "../Components/LeadPreference";
import FollowUpTypesOverview from "../Components/FollowupCountByLeadId";
import InterestProject from "../Components/InterestProject";
import LeadCaptureMethod from "../Components/LeadCaptureMethod";
interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  subMenuList?: [];
}

const LeadDetails: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [showAddTask, setShowAddTask] = useState(false);
  const [refreshTasks, setRefreshTasks] = useState(false);
  const [refreshLeadDashboard, setRefreshLeadDashboard] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        console.log("menuID", menuID);

        if (menuID === undefined || menuID === null || !menuID) {
          // Get current URL
          const currentUrl = window.location.pathname;

          try {
            // Fetch allowed menus
            const menuList = await fetchAllowedMenus();

            // Find the menuID that matches the current URL
            let foundMenuID: number | null = null;

            if (menuList && menuList.length > 0) {
              // Loop through each menu and its submenus
              for (const menu of menuList) {
                if (menu.subMenuList && Array.isArray(menu.subMenuList)) {
                  for (const subMenu of menu.subMenuList) {
                    // Type assertion since we know the structure but interface doesn't define it
                    const subMenuItem = subMenu as any;
                    if (subMenuItem.subMenuUrl === currentUrl) {
                      foundMenuID = menu.menuID;
                      localStorage.setItem(
                        "activeMenuID",
                        foundMenuID.toString()
                      );
                      break;
                    }
                  }
                }
                if (foundMenuID) break;
              }
            }

            if (foundMenuID !== null) {
              localStorage.setItem("activeMenuID", foundMenuID.toString()); // Convert number to string
              console.log("Found and stored menuID:", foundMenuID);
            } else {
              localStorage.removeItem("activeMenuID");
            }
          } catch (error) {
            console.error("Error fetching allowed menus:", error);
          }
        } else {
          // Original logic for when menuID is defined
          const previousMenuID = localStorage.getItem("activeMenuID");
          const menuIDString = menuID.toString(); // Convert number to string
          if (menuIDString !== previousMenuID || menuID === null) {
            localStorage.setItem("activeMenuID", menuIDString);
          } else {
            localStorage.removeItem("activeMenuID");
          }
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, []);
  const handleTaskCreated = () => {
    setShowAddTask(false);
    setRefreshTasks(true);
  };

  return (
    <div className="wrapper">
      <div>
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerStyle={{
            zIndex: 10000,
          }}
        />
      </div>
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-lg-12">
                  <div className="col-12 col-lg-12 ">
                    <LeadDashboardView
                      leadId={location.state.leadId}
                      onTaskCreated={handleTaskCreated}
                    />
                  </div>
                  <div className="col-12 col-lg-12">
                    <FollowUpTypesOverview
                      leadId={location.state.leadId}
                      refreshTasks={refreshTasks}
                      onTasksRefreshed={() => setRefreshTasks(false)} // Reset refresh state
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  {" "}
                  <div className="col-12 col-lg-12">
                    <UserTasksViewDashboard
                      leadId={location.state.leadId}
                      onAddTask={() => setShowAddTask(true)}
                      refreshTasks={refreshTasks}
                      onTasksRefreshed={() => setRefreshTasks(false)}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="col-12 col-lg-12">
                    <UserTaskDashboard
                      leadId={location.state.leadId}
                      onTaskCreated={handleTaskCreated}
                    />
                  </div>
                  <div className="col-12 col-lg-12">
                    <LeadPreferenceDashboardView
                      leadId={location.state.leadId}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-12 col-lg-12 mb-3">
                      <InterestProject leadId={location.state.leadId} />
                    </div>
                    <div className="col-12 col-lg-12">
                      <LeadGroupAssign leadId={location.state.leadId} />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="col-12 col-lg-12">
                    <LeadCaptureMethod leadId={location.state.leadId} />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default LeadDetails;
